import PropTypes from 'prop-types';

const propTypes = {
    /** Processed title to display for the MenuItem */
    title: PropTypes.string.isRequired,
};

export default propTypes;
